
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.8 28.5h8.6c1 0 1 3.1 0 3.1h-8.6v7.7c0 1.9-1.4 1.9-1.4 0v-7.7h-8.6c-1 0-1-3.1 0-3.1h8.6v-7.7c0-1.9 1.4-1.9 1.4 0v7.7z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 30c.4-12.2 9.3-23 22.1-23 12.6 0 22.1 10.8 22.1 23s-9.6 23-22.1 23C17.3 53 8.4 42.2 8 30zm1.4 0c.3 11.4 10.1 20.2 21.4 19.9 10.6-.3 20.1-9 20.1-19.9 0-11.1-10-19.9-20.8-19.9-11 0-20.4 8.8-20.7 19.9z"}})])
          )
        }
      }
    